import React, { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { useDispatch } from 'react-redux';

import { signInRequest } from '../../../../features/adminUserSlice';
import { DescriptionAlert } from '../../../../components/Shared';
import { 
  StyledWrapper,
  StyledWrapTextField,
  WrapTextContent,
  StyledWrapButton,
  useInputStyles,
} from './SignInAdmin.styled';

function Copyright() {
  return (
    <WrapTextContent>
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © '}
        <Link color="inherit" href="https://bktraffic.com/home">
          BK Traffic
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    </WrapTextContent>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignInAdmin() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const classesInput = useInputStyles();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleOnChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === 'username') {
      setUsername(value);
    } else {
      setPassword(value);
    }
  }

  const handleClickSignIn = (e) => {
    e.preventDefault();
    const data = { username, password };
    dispatch(signInRequest(data));
  }

  return (
    <StyledWrapper>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <form className={classes.form} noValidate onSubmit={handleClickSignIn}>
            <StyledWrapTextField>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="username"
                label="Username"
                name="username"
                autoComplete="username"
                autoFocus
                onChange={handleOnChange}
                classes={classesInput}
              />
            </StyledWrapTextField>
            <StyledWrapTextField>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={handleOnChange}
              />
            </StyledWrapTextField>
            <StyledWrapButton>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={handleClickSignIn}
              >
                Sign In
              </Button>
            </StyledWrapButton>
          </form>
        </div>
        <Box mt={8}>
          <Copyright />
        </Box>
        <DescriptionAlert />
      </Container>
    </StyledWrapper>
  );
}
